import { FormControl, TextareaAutosize, Typography } from "@mui/material";
import { ChangeEvent, useState } from "react";
import { ILearningObjectivesProps } from "../types/interfaces/ILearningObjectivesProps";

//This component is responsible for rendering the objectives input. 
const ObjectivesInput: React.FC<ILearningObjectivesProps> = ({ isReadOnly, objectives, onObjectivesChange }) => {
    const [text, setText] = useState<string | null>(objectives);
    const maxLength = 6000;
    const placeholderText = `${maxLength} Character Limit`;
    let remainingChars = maxLength;
    
    if (text !== null && text.length > 0) {
        remainingChars = maxLength - text.length;
    }

    //Function to handle objectives change.
    const objectivesChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
        setText(e.target.value.slice(0, maxLength));
        onObjectivesChange(e.target.value);
    }
    
    return (
        <FormControl sx={{ m: 1, width: "60%", minWidth: 255 }}>
            <TextareaAutosize
                id="goals"
                minRows={3}
                placeholder={placeholderText}
                maxLength={maxLength}
                value={text || ''}
                disabled={isReadOnly}
                onChange={(e) => objectivesChange(e)} />
            <Typography variant="body2" align="right">
                {remainingChars} characters left
            </Typography>
        </FormControl>
    );
}

export default ObjectivesInput;